export default __webpack_public_path__ + "static/media/phone-small.0c0bc8c2.png";